import { START_LOCATION, type Router } from 'vue-router'
import { DomStorage } from '@/enums/dom-storage.enum'

const markReloadOnce = (): boolean => {
  try {
    if (sessionStorage.getItem(DomStorage.PRELOAD_ERROR_RELOADED)) return false
    sessionStorage.setItem(DomStorage.PRELOAD_ERROR_RELOADED, 'true')
    return true
  } catch {
    return false
  }
}

// Once a page is shown, a reload would lose input and job drafts held only in memory.
// No preventDefault: Vite rethrows, so vue-router still logs the failure.
const installPreloadErrorReload = (router: Router) => {
  window.addEventListener('vite:preloadError', () => {
    if (router.currentRoute.value !== START_LOCATION) return
    if (!markReloadOnce()) return
    window.location.reload()
  })
}

export default installPreloadErrorReload
